import React, {Component} from 'react'
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

class OpenCamera extends Component {

    constructor(props) {
        super(props);
        this.state ={
            image_data: null
        };
    }

    onTakePhoto (dataUri) {
        // Do stuff with the dataUri photo...
        this.setState({ image_data: dataUri });
    }

    render() {
        return (<div>
            <Camera
                onTakePhoto = { (dataUri) => { this.onTakePhoto(dataUri); } }
                isFullscreen = {true}
            />
        </div>);
    }
}

export default OpenCamera;